import React from 'react';
import SEO from '../components/SEO';
import Header from "../partials/header/Header";
import Breadcrumb from '../container/Breadcrumb/Breadcrumb';
import Footer from '../container/Footer/Footer';
import ScrollToTop from '../components/ScrollToTop.jsx';
import EmptyTwo from '../container/Empty/EmptyTwo';
// import {Link} from "react-router-dom";

// import EmptyOne from '../container/Empty/EmptyOne';






const Submission = () => {
    return (
        <React.Fragment>
            <SEO title="Submission | ICSI 2025" />
            <Header />
            <Breadcrumb 
                image="images/banner/banner.jpg"
                title="Submission"
                content="For Authors"
                contentTwo="Submission"
				linkage="/"

            />

            {/* <HomeAbout /> */}
			
            <EmptyTwo>



            {/* DONE: add submission button */}
			<div className="row">
			<h5>Click the link below to submit your paper to ICSI 2025</h5>
			<a className="btn btn-primary btn-hover-secondary mt-xl-8 mt-lg-8 mt-md-6 mt-4" href="https://easychair.org/conferences/?conf=icsi2025" >ICSI Online Paper Submission
			</a>
			</div>
			<p>&nbsp;</p>

            <div align="center" className="text-submission">
									<p>If you can&apos;t login the online submission system, please try to submit via
										email <a href="mailto:icsi2025@iasei.org">icsi2025@iasei.org</a></p>
								</div>
								<p>&nbsp;</p>
								<h4>Submission Guidelines</h4>
								<div align="justify">
									<p>Prospective authors are invited to submit full-length papers (10-12+ pages) to ICSI
										2025 through the Online Paper Submission Systems, respectively, by the
										submission deadline. The submission of a paper implies that the paper is
										original and unpublished and will be presented by an author if accepted.
										Potential special session organizers are also invited to enlist five or more
										papers with cohesive topics to form special sessions.</p>
									<p>All papers should be submitted electronically via Online Paper Submission
										Systems. The format of the initial submissions must be standard Springer LNCS
										style PDF. The files of the final accepted papers should be in either Word or
										Latex. Enquiries on paper submissions can be addressed to the secretariat at <a
											href="mailto:icsi2025@iasei.org">icsi2025@iasei.org</a>.</p>
									<p>A complete paper should be submitted using the Springer LNCS template, which is
										blind-submission review-formatted template. The length should match that
										intended for final publication. Note that the ICSI 2025 reviewing is double
										blind, in that authors do not know the names of the reviewers of their papers,
										and reviewers do not know the names of the authors. Please read <a className="simple-link"
											href="./files/anonymous_sample_paper.pdf">the Example
											Paper</a> for detailed instructions on how to preserve anonymity. Avoid
										providing information that may identify the authors in the acknowledgments
										(e.g., co-workers and grant IDs) and in the supplemental material. Avoid
										providing links to websites that identify the authors.</p>
									<p>All submitted papers will be refereed double-blindly by experts in the respective
										fields according to the criteria of originality, significance, quality, and
										clarity. The authors of accepted papers will have an opportunity to revise their
										papers and take consideration of the referees’ comments and suggestions, before
										submitting the final camera-ready version.</p>
									<p>Papers presented at ICSI 2025 will be published in Springer Lecture Notes in
										Computer Science (indexed by EI Compendex, ISI proceedings, ISTP, DBLP, etc.)
										and some high-quality papers will be selected for several SCI-indexed journals.
									</p>
								</div>
								<p>&nbsp;</p>

								<h4>Paper Format</h4>
								<div align="justify">
									<p>Papers must be single-spaced in one column format within an area of 122 mm x 193
										mm with 10-point Times-Roman font. Each paper must exceed 10 pages including figures and references <span className='font-red font-bold'> (papers beyond 12 pages are
										subject to page surcharge) </span>. All papers must be written in English using the
										Springer LNCS (Lecture Notes in Computer Science) style, including all tables,
										figures, and references. It is required that the authors use the style file of
										Springer Lecture Notes in Computer Science (template files for <a className="simple-link"
											href="./files/LNCS-Office2007.zip">MS
											Word</a> or <a className="simple-link"
											href="./files/llncs2e.zip">LaTeX2e</a>, or view it on <a className="simple-link"
											href="https://www.overleaf.com/latex/templates/springer-lecture-notes-in-computer-science/kzwwpvhwnvfj#.WuA4JS5uZpi">Overleaf</a> )
										when preparing the manuscripts to ensure the uniformity of papers.<br />
										For detials, please visit “<a className="simple-link"
											href="http://www.springer.com/computer/lncs?SGWID=0-164-6-793341-0"
											>Information for Authors of Computer Science
											Publications</a>” on the website of Springer.</p>
								</div>
								<p>&nbsp;</p>

								<h4>Presentation Modes</h4>
								<div align="justify">
									<p>The presentation mode of a paper can be oral or poster depending on the
										preference of the authors and arrangement of the organizers. The authors can
										indicate their preferences on oral or poster presentation when submitting
										papers.</p>
								</div>
            </EmptyTwo>
            {/* <AboutFive />
            <TestimonialContainer classOption="bg-primary-blue" />
            <CallToActionTwo /> */}
            <Footer />
            <ScrollToTop />
        </React.Fragment>
    )
}

export default Submission;



